import { create } from "zustand";

interface ErrorState {
  open: boolean;
  message: string | null;
  showError: (msg: string) => void;
  closeError: () => void;
}

const useErrorStore = create<ErrorState>((set) => ({
  open: false,
  message: null,
  showError: (msg) => set({ open: true, message: msg }),
  closeError: () => set({ open: false, message: null }),
}));

export default useErrorStore;
